import { NpoPlayerEvent } from '../../types/events';
export const removeEventListeners = (playerContext) => {
    const { eventListeners } = playerContext.npoplayer;
    if (eventListeners) {
        const { segmentHandleTimeChangedCallback, segmentSeekFunctionCallback, liveStreamHandleTimeChangedCallback } = eventListeners;
        const eventMapping = [
            { event: NpoPlayerEvent.TimeChanged, callback: liveStreamHandleTimeChangedCallback },
            { event: NpoPlayerEvent.TimeChanged, callback: segmentHandleTimeChangedCallback },
            { event: NpoPlayerEvent.Seek, callback: segmentSeekFunctionCallback }
        ];
        for (const { event, callback } of eventMapping) {
            if (callback) {
                playerContext.player.off(event, callback);
            }
        }
        playerContext.npoplayer.eventListeners = undefined;
    }
};
